const identifiedUserId = () => {
  const distinctId = window.posthog.get_distinct_id();
  return distinctId === window.posthog.get_property("$device_id")
    ? null
    : distinctId;
};

const syncPosthogUser = () => {
  if (!window.posthog) {
    return;
  }

  const userId =
    document.querySelector('meta[name="app-user-id"]')?.content || null;

  if (userId === identifiedUserId()) {
    return;
  }

  if (userId) {
    window.posthog.identify(userId);
  } else {
    window.posthog.reset();
  }
};

document.addEventListener("posthog:loaded", syncPosthogUser);
document.addEventListener("turbo:load", syncPosthogUser);
